/*
RISKS-SEARCH
Search risk in array
*/

import SearchBar from "@/components/search-bar"
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import { STATUS_SEARCHING } from "@/redux/_status.types"
import { useState, useCallback } from "react"
import riskStore from "../model/risk.store"

export default function RisksSearch() {
  const dispatch = useAppDispatch()
  const search = useAppSelector(riskStore.selectors.search)

  // Local state for SearchBar’s spinner animation
  const [isSearching, setIsSearching] = useState(false)

  const onSearch = useCallback(
    (value: string | null) => {
      const searchValue = value?.trim() ? value.trim() : null

      dispatch(
        riskStore.actions.search({
          value: searchValue,
          columns: ["name"]
        })
      )

      setIsSearching(false)
    },
    [dispatch]
  )

  return (
    <div style={{ width: 200 }}>
      <SearchBar
        searchText={search.value || undefined}
        onSearch={onSearch}
        status={isSearching ? STATUS_SEARCHING : undefined}
        onSearchStart={() => setIsSearching(true)}
      />
    </div>
  )
}
